import { EHappyHoursOfflinePaymentMentionType } from "@src/lib/happyHour/hooks/EHappyHoursOfflinePaymentMentionType";

export enum EHappyHourLocation {
  CART_INFO = "cart_info",
  LISTING_DEFAULT = "listing_default",
  LISTING_WARN = "listing_warn",
  PAYMENT_INFO = "payment_info",
}

export enum EHappyHourMessageDisplayTiming {
  ALL_TIME = 0,
  BEFORE_WARNING_TIME = 1,
  WARNING_TIME = 2,
}

export type HappyHourMessage = {
  id_happy_hour_message?: number | string;
  display_timing?: EHappyHourMessageDisplayTiming;
  offlinePaymentType?: EHappyHoursOfflinePaymentMentionType;
  name?: string;
  url?: string;
  message?: string;
  mention?: string;
  active?: boolean;
  end_date?: string; // format: "YYYY-MM-DD HH:mm:ss"
  start_date?: string; // format: "YYYY-MM-DD HH:mm:ss"
};

export type HappyHourMessagesByLocation = {
  [location in EHappyHourLocation]?: HappyHourMessage;
};

export type HappyHourData = {
  [location in EHappyHourLocation]?: HappyHourMessage;
};
